
<template>
  <div id="app">

    <NavbarComponent v-if="showNavbar" />
    <mispadres v-if="showmispadres" />

    <faltan v-if="showfaltan" />
    <carruselComponent v-if="showcarrusel" />

    <quotemensaje v-if="showquotemensaje" />
    <carruselcomponent2 v-if="showcarrusel2" />

    <dondeycuando v-if="showdondeycuando" />

    <mensajeregalos v-if="showmensajeregalos" />

    <confirmacionasistencia
      :id-invitado="idInvitado ? Number(idInvitado) : null"
      :nombre="nombreVariable"
      :id-festejado="Number(idFestejado)"
    />

    <Codigovestimenta v-if="showcodigovestimenta" />

    <Fotito v-if="showfotito" />

    <InvitadoEvento
      v-if="showInvitadoEvento && isValidIdInvitado"
      :id-invitado="Number(idInvitado)"
      :nombre="nombreVariable"
      :id-festejado="Number(idFestejado)"
    />

    <carruselfina v-if="showcarrusefina" />

    <imgfinal v-if="showimgfinal" />
    <img_fixed v-if="showimg_fixed" />

  </div>
</template>

<script>
import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';

import NavbarComponent from './narvar.vue';
import dondeycuando from './dondeycuando.vue';
import carruselComponent from './carruselComponent.vue';
import mensajeregalos from './mensajeregalos.vue';
import InvitadoEvento from './invitado_evento.vue';
import confirmacionasistencia from './confirmaciónasistencia.vue';
import imgfinal from './imgfinal.vue';
import img_fixed from './img_fixed.vue';
import carruselcomponent2 from './carruselcomponent2.vue';
import faltan from './faltan.vue';
import codigovestimenta from './codigovestimenta.vue';
import mispadres from './mispadres.vue';
import Fotito from './fotito.vue';
import carruselfina from './carruselultimo.vue';

export default {
  name: 'BaseB',

  components: {
    NavbarComponent,
    dondeycuando,
    carruselComponent,
    mensajeregalos,
    InvitadoEvento,
    confirmacionasistencia,
    imgfinal,
    img_fixed,
    carruselcomponent2,
    faltan,
    codigovestimenta,
    mispadres,
    Fotito,
    carruselfina,
  },

  setup() {

    const showNavbar = ref(true);
    const showdondeycuando = ref(true);
    const showcarrusel = ref(true);
    const showmensajeregalos = ref(true);
    const showInvitadoEvento = ref(true);
    const showquotemensaje = ref(true);
    const showfotito = ref(true);
    const showcarrusefina = ref(true);
    const showimgfinal = ref(true);
    const showimg_fixed = ref(true);
    const showcodigovestimenta = ref(true);
    const showfaltan = ref(true);
    const showcarrusel2 = ref(true);
    const showmispadres = ref(true);

    // OBTENER PARÁMETROS DE LA RUTA
    const route = useRoute();

    const idInvitado = ref(
      Number(route.params.idInvitado) || undefined
    );

    const idFestejado = ref(
      Number(route.params.idFestejado) || undefined
    );

    const nombreVariable = ref(route.params.nombre);

    const isValidIdInvitado = computed(() => {
      return (
        idInvitado.value !== undefined &&
        !isNaN(idInvitado.value)
      );
    });

    const isValidFestejado = computed(() => {
      return (
        idFestejado.value !== undefined &&
        !isNaN(idFestejado.value)
      );
    });

    watch(() => route.params.idInvitado, (newId) => {
      idInvitado.value = Number(newId) || undefined;
    });

    watch(() => route.params.idFestejado, (newId) => {
      idFestejado.value = Number(newId) || undefined;
    });

    watch(() => route.params.nombre, (newNombre) => {
      nombreVariable.value = newNombre;
    });

    return {
      showNavbar,
      showdondeycuando,
      showmensajeregalos,
      showcodigovestimenta,
      showInvitadoEvento,
      showquotemensaje,
      showimgfinal,
      showfotito,
      showimg_fixed,
      showfaltan,
      idInvitado,
      showcarrusefina,
      showcarrusel,
      isValidIdInvitado,
      showcarrusel2,
      idFestejado,
      showmispadres,
      nombreVariable,
      isValidFestejado,
    };
  }
};
</script>

<style scoped>
/* Estilos globales para el contenedor */
</style>
